import React from "react";
import { Text, View, StyleSheet } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function StatusIcon(props) {
  return (
    <View style={styles.container}>
      <Svg
        width={props.width !== undefined ? props.width : 24}
        height={props.height !== undefined ? props.height : 20}
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M20.1475 2.647C19.8682 2.40356 19.5366 2.21046 19.1716 2.07871C18.8066 1.94696 18.4154 1.87915 18.0204 1.87915C17.6253 1.87915 17.2341 1.94696 16.8691 2.07871C16.5041 2.21046 16.1725 2.40356 15.8932 2.647L9.58108 8.147C9.50739 8.21094 9.45502 8.29113 9.42959 8.379L8.28193 12.379C8.25801 12.4627 8.25935 12.5504 8.28582 12.6335C8.31229 12.7166 8.36299 12.7924 8.433 12.8534C8.503 12.9144 8.58993 12.9585 8.68532 12.9816C8.78072 13.0047 8.88134 13.0058 8.97741 12.985L13.568 11.985C13.6692 11.9633 13.7616 11.918 13.8354 11.854L20.1475 6.354C20.4269 6.11061 20.6485 5.82165 20.7997 5.50362C20.9509 5.1856 21.0288 4.84473 21.0288 4.5005C21.0288 4.15626 20.9509 3.8154 20.7997 3.49737C20.6485 3.17934 20.4269 2.89039 20.1475 2.647ZM16.7046 3.354C17.0535 3.04993 17.5268 2.8791 18.0204 2.8791C18.5139 2.8791 18.9872 3.04993 19.3362 3.354C19.6851 3.65807 19.8812 4.07048 19.8812 4.5005C19.8812 4.93052 19.6851 5.34293 19.3362 5.647L13.1354 11.049L9.62698 11.813L10.5038 8.756L16.7046 3.354ZM11.7077 4C12.029 4 12.3435 4.02 12.6522 4.056L13.6323 3.202C11.9287 2.83604 10.1344 2.96615 8.52357 3.57246C6.91278 4.17876 5.5741 5.22791 4.71209 6.55959C3.85007 7.89127 3.51212 9.43225 3.74989 10.947C3.98765 12.4618 4.78805 13.8672 6.02878 14.9483C7.2695 16.0294 8.88233 16.7268 10.6208 16.934C12.3593 17.1411 14.1278 16.8467 15.6561 16.0955C17.1844 15.3444 18.3885 14.178 19.0843 12.7744C19.7801 11.3709 19.9294 9.80745 19.5095 8.323L18.5294 9.177C18.7217 10.3873 18.4854 11.6199 17.852 12.71C17.2187 13.8001 16.2185 14.6957 14.9852 15.2772C13.7519 15.8586 12.3442 16.098 10.9505 15.9635C9.55676 15.829 8.24338 15.327 7.18597 14.5245C6.12855 13.722 5.37751 12.6574 5.03328 11.4729C4.68904 10.2885 4.76802 9.04069 5.25964 7.89641C5.75127 6.75212 6.63211 5.7659 7.78438 5.0696C8.93666 4.37331 10.3054 4.00014 11.7077 4Z"
          fill={props.fill !== undefined ? props.fill : "#808080"}
        />
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
